(() => {
  const TARGET = '#2F3B27';

  const parseRgb = (value) => {
    if (!value || value === 'transparent') return null;
    const m = value.match(/rgba?\(\s*([0-9.]+)\s*,\s*([0-9.]+)\s*,\s*([0-9.]+)(?:\s*,\s*([0-9.]+))?\s*\)/i);
    if (!m) return null;
    return {
      r: Number(m[1]),
      g: Number(m[2]),
      b: Number(m[3]),
      a: m[4] === undefined ? 1 : Number(m[4])
    };
  };

  const isBlackish = (rgb) => {
    if (!rgb || rgb.a < 0.72) return false;
    return rgb.r <= 42 && rgb.g <= 42 && rgb.b <= 42;
  };

  const isHomepage = () =>
    document.body.classList.contains('template-index') ||
    document.documentElement.classList.contains('template-index') ||
    location.pathname === '/' ||
    location.pathname === '';

  const skip = (el) => {
    if (!(el instanceof HTMLElement)) return true;
    if (el.closest('header, footer, .header, .footer, .announcement-bar')) return true;
    if (el.matches('img, picture, video, canvas, svg, iframe')) return true;

    const style = getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden') return true;

    const rect = el.getBoundingClientRect();
    if (rect.width < 80 || rect.height < 50) return true;

    return false;
  };

  const scan = (scope = document) => {
    if (!isHomepage()) return;

    const main = scope.querySelector?.('main') || document.querySelector('main');
    if (!main) return;

    main.querySelectorAll('*').forEach((el) => {
      if (skip(el)) return;
      if (el.dataset.eliznaHomeGreenHandled === '1') return;

      const style = getComputedStyle(el);
      const bg = parseRgb(style.backgroundColor);

      if (!isBlackish(bg)) return;

      const rect = el.getBoundingClientRect();
      const area = rect.width * rect.height;

      // Avoid recoloring tiny inline details/icons. Focus on section-scale surfaces
      // and obvious CTA-sized rectangles.
      const sectionLike =
        area >= 30000 ||
        rect.width >= window.innerWidth * 0.45 ||
        el.matches('section, article, .section, [class*="section"]');

      const buttonLike =
        el.matches('button, a.button, .button, [role="button"]') &&
        area >= 1800;

      if (!sectionLike && !buttonLike) return;

      el.style.setProperty('background-color', TARGET, 'important');

      // Only remove gradient/image when the "image" is a CSS gradient,
      // never when it is an actual URL-based background image.
      if (
        style.backgroundImage &&
        style.backgroundImage !== 'none' &&
        !/url\(/i.test(style.backgroundImage)
      ) {
        el.style.setProperty('background-image', 'none', 'important');
      }

      if (buttonLike) {
        el.style.setProperty('border-color', TARGET, 'important');
      }

      el.dataset.eliznaHomeGreenHandled = '1';
    });
  };

  const init = () => {
    if (!isHomepage()) return;

    scan();

    const observer = new MutationObserver((mutations) => {
      let shouldRescan = false;

      for (const mutation of mutations) {
        if (mutation.addedNodes?.length) {
          shouldRescan = true;
          break;
        }
      }

      if (shouldRescan) {
        requestAnimationFrame(() => scan());
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    window.addEventListener('load', () => scan(), { once: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => {
    requestAnimationFrame(() => scan());
  });
})();
